import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DropdownStateService {
  private readonly prefix = 'wtaf.dropdown-state.';
  private readonly defaultTtlMs = 10 * 60 * 1000;

  private buildKey(key: string): string {
    return this.prefix + key;
  }

  get<T>(key: string): T | null {
    const storageKey = this.buildKey(key);
    try {
      const rawValue = localStorage.getItem(storageKey);
      if (!rawValue) {
        return null;
      }
      const entry = JSON.parse(rawValue);
      const expiresAt = entry && entry.expiresAt;
      if (!entry || typeof entry !== 'object' ||
          !Object.prototype.hasOwnProperty.call(entry, 'value') ||
          typeof expiresAt !== 'number' || !Number.isFinite(expiresAt) ||
          expiresAt <= Date.now()) {
        this.remove(key);
        return null;
      }
      return entry.value as T;
    } catch (error) {
      this.remove(key);
      return null;
    }
  }

  set(key: string, value: any, ttlMs: number = this.defaultTtlMs): void {
    const ttl = Number(ttlMs);
    const normalizedTtlMs = Number.isFinite(ttl) && ttl > 0 ? ttl : this.defaultTtlMs;
    try {
      localStorage.setItem(this.buildKey(key), JSON.stringify({
        value,
        expiresAt: Date.now() + normalizedTtlMs
      }));
    } catch (error) {
      // Persistence is optional when browser storage is unavailable or full.
    }
  }

  remove(key: string): void {
    try {
      localStorage.removeItem(this.buildKey(key));
    } catch (error) {
      // Storage restrictions must not prevent using or resetting a form.
    }
  }
}